<div class="preview-container">
    <h1 mat-dialog-title>
        {{'documents.preview-dialog.title' | translate}}
        <button mat-icon-button mat-dialog-close>
            <fa-icon [icon]="faTimes" size="lg"></fa-icon>
        </button>
    </h1>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
        <div class="document-container">
            <div class="document" [style.width.px]="imageWidth * imageScale">
                <img [src]="imageUrl" alt="{{'documents.preview-dialog.empty' | translate}}">
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-actions>

        <button mat-raised-button type="button" color="primary" (click)="onPrevious()" [disabled]="previousId == -1">
            <fa-icon [icon]="faPrevious" size="lg"></fa-icon>
        </button>

        <!-- <span style="margin-right: 8px;" *ngIf="data.isReceipt">
            <button mat-raised-button type="button" color="primary" (click)="openSendDialog('email')">{{'documents.preview-dialog.send-as-email' | translate}}</button>
            
            <button mat-raised-button type="button" color="primary">{{'documents.preview-dialog.send-as-sms' | translate}}</button>
        </span> -->
        <!-- <button *ngIf="data.isReceipt" mat-raised-button type="button" color="primary"
            (click)="openSendDialog('email')">{{'documents.preview-dialog.send-as-email' | translate}}</button> -->

        <button mat-raised-button type="button" color="primary"
            (click)="onPrint(getImageWidthInMm(imageWidth))">{{'documents.preview-dialog.print' | translate}}</button>

        <button mat-raised-button type="button" color="primary" (click)="onNext()" [disabled]="nextId == -1">
            <fa-icon [icon]="faNext" size="lg"></fa-icon>
        </button>
    </div>
</div>